import React from "react";
import { Link } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";

export default function PrintablesNav() {
  const categories = ["coloring-pages", "activity-pages", "worksheets", "teacher-resources"];

  return (
    <div className="printablesnav">
      <div className="printablesnav-container">
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${categories[0]}`}
          className={`printablesnav-link ${categories[0]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.0")}
        </Link>
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${categories[1]}`}
          className={`printablesnav-link ${categories[1]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.1")}
        </Link>
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${categories[2]}`}
          className={`printablesnav-link ${categories[2]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.2")}
        </Link>
        <Link
          to={`${routeCodes.CATEGORYPRINTABLES}${categories[3]}`}
          className={`printablesnav-link ${categories[3]}`}
          data-testid="printable-nav-link"
        >
          {getString("printables.categories.3")}
        </Link>
      </div>
    </div>
  );
}
